import { header } from 'utils/auth';
import { ensureCsrfToken } from 'utils/csrf';
// import { notifyForbiddenError } from 'utils/notifyForbiddenError';

/** Cookie session (`credentials`) + optional Bearer + CSRF for mutating requests. */
export async function authenticatedFetch(
  input: RequestInfo,
  init: RequestInit = {},
): Promise<Response> {
  const method = String(init.method || 'GET').toUpperCase();
  const headers = new Headers(init.headers);
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) {
    try {
      const csrf = await ensureCsrfToken();
      if (csrf) headers.set('X-CSRF-Token', csrf);
    } catch (e) {
      console.warn('authenticatedFetch CSRF', e);
    }
  }
  const auth = header();
  if (auth) {
    headers.set('Authorization', auth);
  }
  const response = await fetch(input, {
    ...init,
    credentials: 'include',
    headers,
  });
  // if (response.status === 403) {
  //   let responseData: unknown;
  //   try {
  //     responseData = await response.clone().json();
  //   } catch {
  //     responseData = undefined;
  //   }
  //   notifyForbiddenError(
  //     {
  //       statusCode: 403,
  //       responseData,
  //     },
  //     {
  //       method,
  //       url: typeof input === 'string' ? input : input.url,
  //     },
  //   );
  // }
  return response;
}
